"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const moment_1 = __importDefault(require("moment"));
const react_i18next_1 = require("react-i18next");
const data_1 = require("@@/assets/data");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const styled_1 = __importDefault(require("@emotion/styled"));
const deliveryTypeObj = {
    '1': '고정배송',
    '2': '무료배송',
    '3': '구매 개수 별 차등 배송',
    '4': '조건부 무료배송',
    '6': '구매자 맞춤 배송',
};
function default_1() {
    const currentLang = (0, detect_utils_1.currentLanguage)();
    const deliveryRegion = (0, react_redux_1.useSelector)((state) => state.roomData.delivery_region);
    const countries = currentLang === 'ko' ? data_1.countryKr : data_1.countryEn;
    const currentCountryObj = countries.find(obj => obj.value === deliveryRegion);
    const currentCountryCode = (currentCountryObj === null || currentCountryObj === void 0 ? void 0 : currentCountryObj.value) || '';
    const currentCountryName = (currentCountryObj === null || currentCountryObj === void 0 ? void 0 : currentCountryObj.name) || '';
    const paytype = (0, react_redux_1.useSelector)((state) => state.roomData.paytype);
    const isLoginRequired = paytype === 'login_required';
    const isCertifiedRequired = paytype === 'certified_required';
    const isUnder14 = paytype === 'under_14';
    const isParentalConsent = paytype === 'parental_consent';
    const isAdultOnly = paytype === 'adult_only';
    const secondPaid = (0, react_redux_1.useSelector)((state) => state.roomData.second_paid);
    const secondCustom = (0, react_redux_1.useSelector)((state) => state.roomData.second_custom);
    const isQuestion = (0, react_redux_1.useSelector)((state) => state.roomData.is_question);
    const { t } = (0, react_i18next_1.useTranslation)();
    const getSecondRequiredText = () => {
        let secondRequiredArr = [];
        secondPaid && secondRequiredArr.push(t('2차 결제'));
        secondCustom && secondRequiredArr.push(t('개인통관고유부호'));
        isQuestion && secondRequiredArr.push(t('추가질문/답변'));
        return secondRequiredArr.join(', ');
    };
    const endDate = (0, react_redux_1.useSelector)((state) => state.roomData.end_date);
    const formattedEndDate = endDate ? (0, moment_1.default)(endDate).format('YYYY.MM.DD ahh:mm') : '미선택';
    const deliveryStartDate = (0, react_redux_1.useSelector)((state) => state.roomData.support_delivery_date);
    const formattedDeliveryDate = deliveryStartDate
        ? (0, moment_1.default)(deliveryStartDate).format('YYYY.MM.DD ahh:mm')
        : '미선택';
    // ? 상시판매(regularSales일 때 endDate와 deliveryStartDate 표시 안함 (2022.04.07 ~)
    const isRegularSales = (0, react_redux_1.useSelector)((state) => state.regularSales);
    const deliveryType = (0, react_redux_1.useSelector)((state) => state.deliveryType);
    const deliveryTypeText = deliveryTypeObj[deliveryType];
    const deliveries = (0, react_redux_1.useSelector)((state) => state.roomData.deliveries);
    const fixedDeliveries = (0, react_redux_1.useSelector)((state) => state.fixedDeliveries); // 1
    const diffDeliveries = (0, react_redux_1.useSelector)((state) => state.diffDeliveries); // 3
    const conditionalDeliveries = (0, react_redux_1.useSelector)((state) => state.conditionalDeliveries); // 4
    const additionalDeliveries = (0, react_redux_1.useSelector)((state) => state.additionalDeliveries); // 5
    const customDeliveries = (0, react_redux_1.useSelector)((state) => state.customDeliveries); // 6
    const isCustomDelivery = deliveryType === '6';
    const isFeeFree = (0, react_redux_1.useSelector)((state) => state.roomData.fee_free);
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const generateDeliveriesLiTags = (type) => {
        var _a, _b, _c;
        let targetInfos = [];
        if (isPreview) {
            switch (type) {
                case '1':
                    targetInfos = fixedDeliveries;
                    break;
                case '3':
                    targetInfos = diffDeliveries;
                    break;
                case '4':
                    targetInfos = conditionalDeliveries;
                    break;
                case '6':
                    targetInfos = customDeliveries;
                    break;
            }
        }
        else {
            targetInfos = deliveries.filter(obj => obj.delivery_type === Number(type));
        }
        switch (type) {
            case '1':
                return (0, jsx_runtime_1.jsx)("li", { children: ` • ${(0, string_utils_1.money)(((_a = targetInfos[0]) === null || _a === void 0 ? void 0 : _a.delivery_price) || 0)}${t('원')}` });
            case '3':
                return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: targetInfos.map((obj, idx) => {
                        const { number, delivery_price } = obj;
                        return ((0, jsx_runtime_1.jsx)("li", { children: ` • ${number}${t('개 이상 구매시')} ${(0, string_utils_1.money)(delivery_price || 0)}${t('원')}` }, `differential_infos_${idx}_${number}_${delivery_price}`));
                    }) }));
            case '4':
                return ((0, jsx_runtime_1.jsx)("li", { children: ` • ${(0, string_utils_1.money)(((_b = targetInfos[0]) === null || _b === void 0 ? void 0 : _b.delivery_price) || 0)}${t('원')}(${(0, string_utils_1.money)(((_c = targetInfos[0]) === null || _c === void 0 ? void 0 : _c.number) || 0)}${t('원 이상 무료배송')})` }));
            case '6':
                return targetInfos.map(obj => obj.name).join(' / ');
            default:
                return;
        }
    };
    const additionalShippingFeeText = (() => {
        var _a, _b;
        const additionalFee = (isPreview
            ? (_a = additionalDeliveries[0]) === null || _a === void 0 ? void 0 : _a.delivery_price
            : (_b = deliveries.find(delivery => delivery.delivery_type === 5)) === null || _b === void 0 ? void 0 : _b.delivery_price) || 0;
        if (additionalFee)
            return `${t('제주/도서산간 추가운송료')} ${(0, string_utils_1.money)(additionalFee)}${t('원')}`;
        else
            return t('제주/도서산간은 추가운송료가 발생될 수 있어요.');
    })();
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const viewCounts = (0, react_redux_1.useSelector)((state) => state.roomData.view_counts);
    return ((0, jsx_runtime_1.jsxs)(ShippingDiv, { children: [isDemandSurvey ? (!!viewCounts && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/images/view_count_face.webp`, className: "padded_svg" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "description" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "highlight" }, { children: `${(0, string_utils_1.money)(viewCounts)}${t('명')}` })), t('이 관심있어요')] }))] }))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                            position: 'relative',
                            flexShrink: 0,
                            display: 'flex',
                            width: '18px',
                            margin: '0 3px',
                            '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '2px' }),
                        } }, { children: (0, jsx_runtime_1.jsx)("img", { alt: currentCountryName, src: `https://flagcdn.com/w20/${currentCountryCode.toLowerCase()}.webp`, srcSet: `https://flagcdn.com/w40/${currentCountryCode.toLowerCase()}.webp 2x`, css: { width: '100%', borderRadius: '2px' } }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "description" }, { children: [t('P-으로 배송'), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "highlight" }, { children: currentCountryName })), t('S-으로 배송')] }))] })), !isLoginRequired && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isCertifiedRequired && ((0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/certified_required.svg`, className: "padded_svg" })), isUnder14 && ((0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/under_14.svg`, className: "padded_svg" })), isParentalConsent && ((0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/parental_consent.svg`, className: "padded_svg" })), isAdultOnly && ((0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/adult_only.svg`, className: "padded_svg" })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "description" }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "highlight" }, { children: [isCertifiedRequired && t('본인인증'), isUnder14 && t('만 14세 이상'), isParentalConsent && t('미성년자 법정대리인 동의'), isAdultOnly && t('성인만')] })), (isCertifiedRequired || isParentalConsent) && t('필요'), (isUnder14 || isAdultOnly) && t('구매 가능')] }))] })), (secondPaid || secondCustom || isQuestion) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/second_paid.svg`, className: "padded_svg" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "description" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "highlight significant" }, { children: getSecondRequiredText() })), t('필요')] }))] })), !isRegularSales && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/sales_end_clock.svg`, className: "padded_svg" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "description" }, { children: [t(isDemandSurvey ? 'P-에 수요조사 마감' : 'P-에 판매 종료'), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "highlight" }, { children: formattedEndDate })), t(isDemandSurvey ? 'S-에 수요조사 마감' : 'S-에 판매 종료')] })), !isDemandSurvey && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/shipping_box.svg`, className: "padded_svg" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "description" }, { children: [t('P-이후 배송 예정'), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "highlight" }, { children: formattedDeliveryDate })), t('S-이후 배송 예정')] }))] }))] })), !isDemandSurvey && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/shipping_truck.svg`, className: "padded_svg", id: "shipping_fee_desc_icon" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "description", id: "shipping_fee_desc" }, { children: [!isCustomDelivery && (0, jsx_runtime_1.jsx)("div", Object.assign({ id: "status" }, { children: t(deliveryTypeText) })), generateDeliveriesLiTags(deliveryType), !isCustomDelivery && (0, jsx_runtime_1.jsx)("li", { children: ` • ${additionalShippingFeeText}` })] })), (0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/moneybag_gold.svg`, className: "padded_svg" }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "description" }, { children: t(isFeeFree ? '폰디 계좌로 입금' : '카드결제 / 휴대폰 / Paypal / 폰디 계좌로 입금') }))] }))] }));
}
exports.default = default_1;
const ShippingDiv = styled_1.default.div `
  display: grid;
  grid-template-columns: 28px auto;
  align-items: center;
  row-gap: 8px;
  padding: 20px;
  margin-bottom: 10px;
  background-color: white;
  .description {
    display: flex;
    align-items: center;
    column-gap: 4px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    line-height: 22px;
    word-break: keep-all;
    .highlight {
      font-size: 14px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.8);
    }
    .significant {
      padding: 0 4px;
      border-radius: 4px;
      background-color: #fdf3ec;
      color: #ea3323;
    }
    #status {
      padding-bottom: 4px;
      line-height: inherit;
    }
    li {
      padding-bottom: 6px;
      word-break: break-all;
      list-style: none;
      font-size: 13px;
    }
  }
  .padded_svg {
    width: 24px;
    height: 24px;
    padding: 3px;
  }
  #shipping_fee_desc_icon {
    align-self: flex-start;
  }
  #shipping_fee_desc {
    flex-direction: column;
    align-items: flex-start;
  }
`;
